var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "url(#paint0_linear_2030_1612)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8L7.07991 9.73326C7.26533 9.88778 7.53467 9.88778 7.72009 9.73326L11 7",
    stroke: "#312F3B",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2030_1612",
    x1: 2.41941e-8,
    y1: 8.03018,
    x2: 16,
    y2: 8.03018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0D09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCC95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/selectArrow.fe5fe92a02d1da158c26d0daf9092f29.svg";
export { ForwardRef as ReactComponent };